import styled from 'styled-components'

export const HeaderDiv = styled.div`
  display: flex;
  padding: 1.6vh 2vh;
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,0.1);}
  text-transform: uppercase;
  font-size:17px;
`

export const Title = styled.h4``
